import Maybe from "components/__new/common/Maybe";
import { DateTimeMiniFormat } from "utils/dateFormat";
import useToolkit from "utils/useToolkit";
import { ReactComponent as IconChevronLeft } from "assets/images/icons/project-icons/chevron-left.svg";
import { ReactComponent as IconChevronRight } from "assets/images/icons/project-icons/chevron-right.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as savingsActions from "store/entities/savings/action";


const SavingsTransactions = ({ control, onClose, isFlex }) => {
	const { useSelector, Spinner, Xclose, CurrencyFormat, EmptyUI, avail, dispatch } = useToolkit();
	const { savingsDetailsLoading: loading, savingsTrxData, savingsTrxLoading: trxLoading, selectedSavingsItem } = useSelector((state) => state.entities.savings);
	let transactions = [];
	if (isFlex) {
		transactions = savingsTrxData?.data?.data;
	} else {
		transactions = savingsTrxData?.data;
	}
	
    const detailsNotFound = loading === false && savingsTrxData === null;
    const email = savingsTrxData?.email || "-";
    const firstName = savingsTrxData?.firstName || "";
    const lastName = savingsTrxData?.lastName || "";

	return (
		<div className={
			"max-w-md w-screen h-screen bg-white fixed z-50 top-0 bottom-0 shadow-xl transition-all duration-300 ease-in-out " +
			(control ? "right-0" : "-right-full")
			}>
			<div className="w-full h-full p-5 pb-10 relative overflow-auto overscroll-contain">
				<Maybe condition={!loading && !trxLoading}>
					<div className="flex justify-between">
						<div className="font-recoleta font-semibold text-2xl capitalize">
							{firstName} {lastName || ''}
						</div>
						<div
							onClick={onClose}
							className="w-8 h-8 flex group hover:bg-red-400 rounded-lg cursor-pointer">
							<Xclose className="customizeSVG group-hover:text-white m-auto" />
						</div>
					</div>
				</Maybe>
				<Maybe condition={loading || trxLoading}>
					<Spinner text={loading ? "Fetching details" : trxLoading ? "Fetching transactions" : ""} />
				</Maybe>
				
				<Maybe condition={trxLoading === false && detailsNotFound === true}>
					<EmptyUI text={`User with ${isFlex ? "flex" : "goal"} savings not found`} />
				</Maybe>
				
				<Maybe condition={trxLoading === false && detailsNotFound === false}>
					<div>
						<div className="text-fade text-xs">
							{avail(email)}
						</div>
						<div className="text-fade text-xs">
							<span>Savings type:&nbsp;</span>
							<strong className="text-ep-blue-deeper">{!isFlex ?'Goal' : 'Flex'} Savings</strong>
						</div>
					</div>
				</Maybe>
				
				<Maybe condition={trxLoading === false && transactions?.length === 0}>
					<div className="table-info">
						<FontAwesomeIcon icon="list" />
						<div className="font-bold uppercase">
							No transactions yet
						</div>
					</div>
				</Maybe>
				
				<Maybe condition={trxLoading === false && transactions?.length > 0}>
					<div className="my-6">
						<div className="w-full h-px mt-8 bg-gray-200"></div>
						<div className="mt-6 font-semibold text-sm">
							<h5 className="tracking-wide mb-4">
								User Savings Transactions
							</h5>
							<div className="w-full border border-[#E5E7EB] p-4 pt-0 rounded-md">
								{transactions?.map((trx, index) => {

									const formattedMeta = JSON.parse(trx?.meta)
									const dateCreated =	DateTimeMiniFormat(trx?.createdAt)
									const nairaAmount = CurrencyFormat(trx?.amount / 100)
									// const interestAmount = CurrencyFormat(trx?.interest)
									const isCredit = trx?.type === 'credit' || trx?.type === "interest" || trx?.type === "savings";
									const isWithdrawal = trx?.type === "withdrawal"
									const isFailed = trx?.status === 'failed'
									const isCutOff = formattedMeta?.data?.message?.includes('Withdrawal is stopped, contact your employer')

									const withdrawalColor = '#EF4444'
									const isFailedColor = '#EF4444'
									const creditColor = '#007928'
									const successDark = '#006770'
									const cutOffColor = 'rgba(244,157,27,1)'

									return (
										<div key={trx?.createdAt} className={`w-full flex items-start 
										justify-between text-sm py-2.5 ${index !== transactions?.length -1 && " border-b border-[#E5E7EB]"}`}>
											<div className="">
												<h5 className="mb-1 text-[#1f2937] capitalize">
													{trx?.type}
												</h5>
												<p className="mb-0 text-[#9CA3AF] font-normal">
												{dateCreated}
												</p>
											</div>
											<div className="">
												<h5 style={{
													color: isFailed ? isFailedColor : isCredit ? creditColor : isWithdrawal ? withdrawalColor :
													isCutOff ? cutOffColor : '',
												}} className="mb-1 font-bold">
													{isCredit ? '+' : '-'}{nairaAmount}
												</h5>
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</div>
					
					<Pagination
						savingsTrxData={savingsTrxData}
						selectedSavingsItem={selectedSavingsItem}
						dispatch={dispatch}
						isFlex={isFlex}
					/>
				</Maybe>
			</div>
		</div>
	);
};

export default SavingsTransactions;


const Pagination = ({savingsTrxData, dispatch, selectedSavingsItem, isFlex}) => {
	const paginationData = isFlex ? savingsTrxData?.data : savingsTrxData;
    const prevBtnDisabled = !paginationData?.hasPrevPage;
    const nextBtnDisabled = !paginationData?.hasNextPage;
    
    const sharedClass = "py-1.5 px-3 rounded-sm"
    const sharedActiveBtnClass = "bg-ep-blue-deeper text-white"
    const sharedDisabledBtnClass = "bg-gray-100 cursor-not-allowed text-gray-300"
	const handlePrevPage = () => {
		if (isFlex) {
			dispatch(savingsActions.getFlexSavingsTransactions({
				flexSaving: selectedSavingsItem?.id,
				page: paginationData?.prevPage,
				limit: paginationData?.limit,
			}))
			return;
		}
		dispatch(savingsActions.getSavingsTransactions({
			goalId: selectedSavingsItem?.id,
			page: paginationData?.prevPage,
			limit: paginationData?.limit,
		}))
	}

	const handleNextPage = () => {
		if (isFlex) {
			dispatch(savingsActions.getFlexSavingsTransactions({
				flexSaving: selectedSavingsItem?.id,
				page: paginationData?.nextPage,
				limit: paginationData?.limit,
			}))
			return;
		}
		dispatch(savingsActions.getSavingsTransactions({
			goalId: selectedSavingsItem?.id,
			page: paginationData?.nextPage,
			limit: paginationData?.limit,
		}))
	}

    return (
        <div className="flex items-center justify-between w-full">
            <span className="text-sm">{`Showing ${paginationData?.data?.length} item(s) out of ${paginationData?.totalDocs} result(s) found`}</span>
            <div className="flex items-center">
                <button className={`mr-2 ${sharedClass} ${prevBtnDisabled ? sharedDisabledBtnClass : sharedActiveBtnClass}`} onClick={handlePrevPage} disabled={!paginationData?.hasPrevPage}>
                    <IconChevronRight className="customizeSVG text-lg" />
                </button>
                
                <button className={`${sharedClass} ${nextBtnDisabled ? sharedDisabledBtnClass : sharedActiveBtnClass}`} onClick={handleNextPage} disabled={!paginationData?.hasNextPage}>
                    <IconChevronLeft className="customizeSVG text-lg" />
                </button>
            </div>
        </div>
    );
};